/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';


// Get All Orders (GET)
export const getAllOrders = createAsyncThunk(
  "getAllOrders",
  async ({ page = 1, limit = 12, orderStatus, dateRange,courierStatus,startDate,endDate }) => {
    try {
      const res = await $axios.get(
        `/orders/admin?page=${page}&limit=${limit}&orderStatus=${orderStatus}&dateRange=${dateRange}&courierStatus=${courierStatus}&startDate=${startDate}&endDate=${endDate}`
      );
      console.log(res.data,'server check')
      return { resp: res.data, err: null };
    } catch (err) {
      return { resp: null, err: err.response };
    }
  }
);

export const getReturnOrders = createAsyncThunk(
  "getReturnOrders",
  async ({ page = 1, limit = 12, dateRange = "All", startDate = "", endDate = "", returnStatus = "All", refundStatus = "All" }) => {
    try {
      const res = await $axios.get(
        `/return/return_orders?page=${page}&limit=${limit}&dateRange=${dateRange}&startDate=${startDate}&endDate=${endDate}&returnStatus=${returnStatus}&refundStatus=${refundStatus}`
      );
      console.log(res.data,'server check')
      return { resp: res.data, err: null };
    } catch (err) {
      return { resp: null, err: err.response };
    }
  }
);


// Single Order information (GET)
export const getSingleOrder = createAsyncThunk('get Single order', async (tranId) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/orders/${tranId}`);
    response = [res.data.data, null];
    
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Update Single Order (PATCH)
export const updateSingleOrder = createAsyncThunk('update Single order', async ({orderId, obj}) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/orders/${orderId}`, obj);
    response = [res.data.data, null];
    
  } catch (err) {
    response = [null, err.response];
  } finally {
    return response;
  }
});

// Delete unpaid order (DELETE)
export const deleteUnpaidOrder = createAsyncThunk(
  'orders/deleteUnpaidOrder',
  async (tranId, thunkAPI) => {
    try {
      const res = await $axios.delete(`/orders/delete-unpaid/${tranId}`);
      return { tranId, data: res.data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

// curriar
export const sendToSteadfast = createAsyncThunk(
  'orders/sendToSteadfast',
  async (tranId, thunkAPI) => {
    const { data } = await $axios.put(`/courier/${tranId}/send-to-steadfast`);
    return data;
  }
);

// Return to Steadfast
export const returnToSteadfast = createAsyncThunk(
  'orders/returnToSteadfast',
  async (tranId, thunkAPI) => {
    try {
      const { data } = await $axios.patch(`/return/${tranId}/accept`);
      return data;
    } catch (err) {
     
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Reject Return Request
export const rejectReturnRequest = createAsyncThunk(
  'orders/rejectReturnRequest',
  async (tranId, thunkAPI) => {
    try {
      const { data } = await $axios.patch(`/return/${tranId}/reject`);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// Update Refund Status
export const updateRefundStatus = createAsyncThunk(
  'orders/updateRefundStatus',
  async ( { tranId, status }, thunkAPI ) => {
    try {
      const { data } = await $axios.patch(`/return/${tranId}/refund`, { status });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);




// Slice
const orderSlice = createSlice({
  name: 'orderSlice',
  initialState: {
    allOrders_: null,
    singleOrder: null,
    orders: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    // Fetch Data
     builder
      .addCase(getAllOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });

       // Fetch Return Data
     builder
      .addCase(getReturnOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReturnOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; 
      })
      .addCase(getReturnOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });

    builder
      .addCase(getSingleOrder.pending, (state, action) => {
        state.singleOrder = null;
      })
      .addCase(getSingleOrder.fulfilled, (state, action) => {
        state.singleOrder = action.payload;
      });

         builder
      .addCase(deleteUnpaidOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUnpaidOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = state.orders.filter(o => o.tran_id !== action.payload.tranId);
      })
      .addCase(deleteUnpaidOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

      builder
  .addCase(returnToSteadfast.pending, (state) => { 
    state.loading = true; 
  })
  .addCase(returnToSteadfast.fulfilled, (state, action) => { 
    state.loading = false;
    const idx = state.orders.findIndex(o => o.tran_id === action.payload.tran_id);
    if (idx !== -1) {
      state.orders[idx] = { ...state.orders[idx], ...action.payload.data };
    }
  })
  .addCase(returnToSteadfast.rejected, (state, action) => { 
    state.loading = false; 
    state.error = action.payload || action.error.message;
  });

  builder
  .addCase(updateRefundStatus.pending, (state) => { state.loading = true; })
  .addCase(updateRefundStatus.fulfilled, (state, action) => {
    state.loading = false;
    const idx = state.orders.findIndex(o => o.tran_id === action.payload.data.tran_id);
    if (idx !== -1) {
      state.orders[idx].refund_status = action.payload.data.refund_status;
    }
  })
  .addCase(updateRefundStatus.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload || action.error.message;
  });


  builder
  .addCase(rejectReturnRequest.pending, (state) => {
    state.loading = true;
  })
  .addCase(rejectReturnRequest.fulfilled, (state, action) => {
    state.loading = false;
    // orders list update
    const idx = state.orders.findIndex(o => o.tran_id === action.payload.data.tran_id);
    if (idx !== -1) {
      state.orders[idx].return_request.status = action.payload.data.return_request.status;
    }
  })
  .addCase(rejectReturnRequest.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload || action.error.message;
  });



    builder
      .addCase(updateSingleOrder.pending, (state, action) => {
        state.singleOrder = null;
      })
      .addCase(updateSingleOrder.fulfilled, (state, action) => {
        state.singleOrder = action.payload;
      });

      builder
      .addCase(sendToSteadfast.pending, (state) => { state.loading = true; })
    .addCase(sendToSteadfast.fulfilled, (state, action) => { 
      state.loading = false;
      const idx = state.orders.findIndex(o => o.tran_id === action.payload.tran_id);
      if(idx !== -1) state.orders[idx] = { ...state.orders[idx], ...action.payload.data };
    })
    .addCase(sendToSteadfast.rejected, (state) => { state.loading = false; });
  },
});

export default orderSlice.reducer;
